import React from "react";
import { FieldErrors, useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { Reason } from "../../types";
import styles from "./editPolicy.module.scss";

type EditReasonProps = {
  errors?: FieldErrors;
  isDisabled: boolean;
  reasons: Reason[];
};

const EditReason = ({
  isDisabled,
  reasons,
}: EditReasonProps): React.JSX.Element => {
  const { formState } = useFormContext();

  return (
    <>
      <Form.RadioGroup
        id="predefined-reasons"
        label="Reason"
        isRequired
        name="reason"
        items={reasons.map(({ value, isRecommended }: Reason) => ({
          label: value,
          value: value,
          id: value,
          disabled: isDisabled,
          className: getClassName({
            [styles["policy-reason-recommended"]]: isRecommended && !isDisabled,
          }),
        }))}
        errors={formState.errors}
        helperText="Recommended override reasons are highlighted for you, or you can write
        your own"
      />
      <Form.TextArea
        placeholder="Choose a predefined reason or define your own custom reason"
        name="reason"
        id="custom-reason"
        errors={formState.errors}
        isFullWidth
        minRows={3}
        isDisabled={isDisabled}
      />
    </>
  );
};

export default EditReason;
